import React from "react";
import dynamic from "next/dynamic";
const Section = dynamic(() => import("@/Components/LayoutComponents/Section"),{ssr: true});
const ReviewSlider = dynamic(() => import("./ReviewSlider"), {
  ssr: true,
});

interface ReviewProps {
  data: {
    title: string;
    sub_title: string;
    testimonials: any;
  };
}
const Review: React.FC<ReviewProps> = ({ data }) => {
  return (
    <>
      <Section>
        <div className="w-full px-4 md:container md:mx-auto">
          <div>
            <h2 className="text-heading-1 font-bold text-primary-text text-center">
              {data?.title}
            </h2>

            {data?.sub_title && (
              <p className="text-subtitle-2 text-center font-regular mt-3">
                {" "}
                {data?.sub_title}
              </p>
            )}
          </div>
          <div className="md:mt-10 mt-8">
            <ReviewSlider testimonials={data?.testimonials?.data} />
            {/* <ReviewSlider /> */}
          </div>
        </div>
      </Section>
    </>
  );
};
export default Review;
